import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { asheboroConfig } from "./data";

export default function AsheboroPage() {
  return <CityPageTemplate config={asheboroConfig} />;
}